module.exports = __webpack_public_path__ + "static/img/duom01.14db6e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom01.png
// module id = 432
// module chunks = 0